<template>
  <header>
    <div class="logo">
      <a href="/resume">新竹縣防災人員<span>教育訓練暨學習履歷平台</span></a>
    </div>
    <!-- <a href="#" class="btn-login">登入</a> -->
  </header>
</template>

<script>
export default {}
</script>
